const API_BASE =
  process.env.REACT_APP_CONVERLEAD_API_URL ||
  'https://converlead-api.convertrex.com.br/converlead/api';

/**
 * Inicia checkout via Converlead API → Payment Hub (conta Convertrex / Asaas).
 */
export async function iniciarCheckout({ produtoCodigo, periodoContratacao, nome, email, documento, telefone }) {
  const response = await fetch(`${API_BASE}/assinatura/checkout`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify({
      produtoCodigo,
      periodoContratacao,
      nome: nome.trim(),
      email: email.trim(),
      documento: documento?.trim() || undefined,
      telefone: telefone?.trim() || undefined,
    }),
  });

  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(data.message || data.detail || 'Não foi possível iniciar o pagamento.');
  }

  return data;
}
